module.exports = __webpack_public_path__ + "img/social_responsibility_book_header.9a29bb38.jpg";